import { createAction } from '@reduxjs/toolkit';

export const asyncLoadComments = createAction('[async] asyncLoadComments');
export const asyncLoadCommentsSuccess = createAction('[async] asyncLoadCommentsSuccess');
export const asyncGetShareLink = createAction('[async] asyncGetShareLink');
export const asyncGetSubscriptions = createAction('[async] asyncGetSubscriptions');
